import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

const PlanInterval = ({ planInterval }) => {
  if (!planInterval) {
    return <span />;
  }

  switch (planInterval) {
    case 'month':
      return <FormattedMessage defaultMessage="Monthly" />;
    case 'year':
      return <FormattedMessage defaultMessage="Yearly" />;
    default:
      return <span>{planInterval}</span>;
  }
};

PlanInterval.propTypes = {
  planInterval: PropTypes.string,
};

export default PlanInterval;
